import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryLastActivityReport'
import Component from 'components/Reports/InventoryLastActivityReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryLastActivityReport })(Component)
